// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__eAesw","modalForm":"UpgradeEpcsModal_modalForm__ngJ1S","modalFooter":"UpgradeEpcsModal_modalFooter__1DGpS"};